import React, {useContext, useEffect, useMemo, useState} from 'react'

import {useMaterialDemandFilters} from './MaterialDemandFiltersProvider'

interface MaterialDemandEditState {
  changeIsEditing: (isEditing: boolean) => void
  isEditing: boolean
}

const MaterialDemandEditContext = React.createContext<MaterialDemandEditState | undefined>(
  undefined
)

export const useMaterialDemandEdit = () => {
  const context = useContext(MaterialDemandEditContext)
  if (!context)
    throw new Error(
      'Cannot use MaterialDemandFilterContext outside of a MaterialDemandFilterProvider provider'
    )
  return context
}

export const MaterialDemandEditProvider: React.FC<{children: React.ReactNode}> = ({children}) => {
  const [isEditing, changeIsEditing] = useState(false)
  const {selectedDate} = useMaterialDemandFilters()

  useEffect(() => {
    changeIsEditing(false)
  }, [selectedDate])

  const memoizedState = useMemo(() => ({isEditing, changeIsEditing}), [isEditing, changeIsEditing])

  return (
    <MaterialDemandEditContext.Provider value={memoizedState}>
      {children}
    </MaterialDemandEditContext.Provider>
  )
}
